import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {GeneralComponent} from '../../General/g.component';
import {TopicService} from '../topic.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent extends GeneralComponent implements OnInit {

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService) {
    super(topicService);
  }

  id: number;

  /** called after the constructor */
  ngOnInit() {
    this.id = +this.activatedRoute.snapshot.paramMap.get('id');
    this.getConfiguration();
  }

  get_helperUrl() {
    return this.configuration['helperVideo'];
  }

  get_title(): string {
    return this.configuration['title'];
  }

  getConfiguration() {
    this.configuration = this.topicService.getExerciseById(this.id);
  }
}
